import React from 'react'
import { RegisterPageWrapper } from './RegisterPreviewPageStyled'
import { Statistic } from 'antd'
import { useParams } from 'react-router-dom'
import { REGISTER_ID, STATION_TYPE, VIEW_MODE } from '../../constant'
import RegisterForm from '../../components/RegisterForm'
import { useRecoilValue } from 'recoil'
import { pageConfigDraftState } from '../../recoil/landingPageState'

const { Countdown } = Statistic

const RegisterPreviewPage = props => {
  const { id: registerType } = useParams()
  const pageConfig = useRecoilValue(pageConfigDraftState)
  // console.log(registerType)

  const renderByType = () => {
    switch (registerType) {
      case REGISTER_ID.CASH_FLOW:
        return (
          <RegisterForm
            pageConfig={pageConfig}
            mode={VIEW_MODE.PREVIEW}
            registerType={registerType}
            stationType={STATION_TYPE.BUSINESS}
          />
        )
      case REGISTER_ID.ECOMMERCE:
        return (
          <RegisterForm
            pageConfig={pageConfig}
            mode={VIEW_MODE.PREVIEW}
            registerType={registerType}
            stationType={STATION_TYPE.ECOMMERCE}
          />
        )
      case REGISTER_ID.FINANCE:
        return (
          <RegisterForm
            pageConfig={pageConfig}
            mode={VIEW_MODE.PREVIEW}
            registerType={registerType}
            stationType={STATION_TYPE.FINANCE}
          />
        )
      case REGISTER_ID.KNOWLEDGE:
        return (
          <RegisterForm
            pageConfig={pageConfig}
            mode={VIEW_MODE.PREVIEW}
            registerType={registerType}
            stationType={STATION_TYPE.KNOWLEDGE}
          />
        )
      default:
        return
    }
  }

  return <RegisterPageWrapper>{renderByType()}</RegisterPageWrapper>
}

RegisterPreviewPage.propTypes = {}

export default RegisterPreviewPage
